module.exports = __webpack_public_path__ + "static/media/icon-coin-contact-top.ebf97a76.png";